import { useEffect } from "react";
import { useImmer } from "use-immer";
import { usePOSSyncSettingsQueries } from "./usePOSSyncSettingsQueries";

export const usePOSSyncSettings = () => {
  const [state, setState] = useImmer({
    isLoading: true,
    cost_sync_enabled: false,
    confirmModal: {
      open: false,
      pendingValue: null,
    },
  });

  const { settingsQuery, updateSettingsMutation } = usePOSSyncSettingsQueries();

  // Sync state when settings data is fetched
  useEffect(() => {
    if (settingsQuery?.data) {
      setState((draft) => {
        draft.cost_sync_enabled = settingsQuery.data.cost_sync_enabled || false;
        draft.isLoading = false;
      });
    }
  }, [settingsQuery?.data, setState]);

  const handleToggle = (checked) => {
    setState((draft) => {
      draft.confirmModal.open = true;
      draft.confirmModal.pendingValue = checked;
    });
  };

  const handleConfirmToggle = () => {
    const newValue = state.confirmModal.pendingValue;

    setState((draft) => {
      draft.confirmModal.open = false;
      draft.confirmModal.pendingValue = null;
      draft.cost_sync_enabled = newValue;
    });

    // Call API to save
    updateSettingsMutation.mutate({
      cost_sync_enabled: newValue,
    });
  };

  const handleCancelToggle = () => {
    setState((draft) => {
      draft.confirmModal.open = false;
      draft.confirmModal.pendingValue = null;
    });
  };

  return {
    state,
    isLoading: settingsQuery.isLoading,
    isSaving: updateSettingsMutation.isPending,
    handleToggle,
    handleConfirmToggle,
    handleCancelToggle,
    updateSettingsMutation,
  };
};
